const DRAFT = "toto.guestScan";
const USED = "toto.guestScanUsed";

export const getGuest = () => { try { return JSON.parse(sessionStorage.getItem(DRAFT)); } catch { return null; } };
export const setGuest = (d) => sessionStorage.setItem(DRAFT, JSON.stringify(d));
export const clearGuest = () => sessionStorage.removeItem(DRAFT);
export const guestUsed = () => sessionStorage.getItem(USED) === "1";
export const markGuestUsed = () => sessionStorage.setItem(USED, "1");
export const afterAuthPath = () => (getGuest() ? "/scan/review" : "/");
